var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7507 1.24987C13.0843 -0.416625 10.3574 -0.416625 8.69093 1.24987L5.72835 4.22937C4.0619 5.89587 4.0619 8.60603 5.72835 10.2725C6.16601 10.7102 6.67099 11.03 7.19281 11.232L8.4721 9.9527C8.5226 9.9022 8.58993 9.83486 8.6236 9.76753C8.01762 9.73386 7.41164 9.4982 6.95715 9.02687C5.98085 8.05053 5.98085 6.45137 6.95715 5.47504L9.93656 2.49554C10.9129 1.51921 12.5288 1.50237 13.5051 2.49554C14.4983 3.4887 14.4814 5.08787 13.5051 6.0642L12.1585 7.41087C12.3773 8.20203 12.3942 9.02687 12.2258 9.83486L14.7507 7.30987C16.4172 5.64337 16.4172 2.91637 14.7507 1.24987Z",
    fill: "#434C58",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80778 4.75122L7.52848 6.03055C7.47798 6.08105 7.42749 6.14839 7.37699 6.21572C7.98297 6.24939 8.58895 6.48505 9.04344 6.95638C10.0366 7.94955 10.0197 9.54872 9.04344 10.525L6.06403 13.5045C5.07089 14.4977 3.47177 14.4977 2.49547 13.5045C1.51916 12.5282 1.51916 10.9122 2.49547 9.93588L3.84209 8.58922C3.62327 7.79805 3.60643 6.97322 3.77476 6.16522L1.24984 8.69022C-0.416613 10.3567 -0.416613 13.0837 1.24984 14.7502C2.91629 16.4167 5.62637 16.4167 7.30966 14.7502L10.2891 11.7707C11.9555 10.1042 11.9555 7.39405 10.2891 5.71072C9.85141 5.28989 9.34643 4.97005 8.80778 4.75122Z",
    fill: "#434C58",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.ea4a9f3212dd36cf579008e848a8d687.svg";